// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"361899ea","429":"6ea1d0a3","435":"21193424","474":"e15ddb03","513":"e8034b0c","688":"42395460","758":"cf25abe8","935":"e4afc166","936":"36d8a66b"}[chunkId] + ".chunk.js";
};